export default __webpack_public_path__ + "b739208e306ac0b6f87c950cc58c2b25.svg";